import VerifiedIcon from '@mui/icons-material/Verified';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import StarRateIcon from '@mui/icons-material/StarRate';
import AutoStories from '@mui/icons-material/AutoStories';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import PsychologyIcon from '@mui/icons-material/Psychology';
import DescriptionIcon from '@mui/icons-material/Description';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import { AppProvider } from '@toolpad/core/react-router-dom';
import { Outlet } from 'react-router-dom';
import AuthGuard from './components/AuthGuard';
import LogoIcon from './logo-icon.png';
import './App.css';

const NAVIGATION = [
  {
    segment: 'certificates',
    title: 'Certificates',
    icon: <VerifiedIcon />,
    children: [
      {
        segment: 'simple',
        title: 'Simple',
        icon: <StarHalfIcon />,
      },
      {
        segment: 'divine',
        title: 'Divine',
        icon: <StarRateIcon />,
      },
    ],
  },
  {
    segment: 'page-maker',
    title: 'Page Makers',
    icon: <AutoStories />,
    children: [
      {
        segment: 'flyer',
        title: 'VD - Personal Flyer',
        icon: <PersonPinIcon />,
      },
      {
        segment: 'slide',
        title: 'VD - Video Slide',
        icon: <SlideshowIcon />,
      },
      {
        segment: 'masterful',
        title: 'VD - Masterful Minds',
        icon: <PsychologyIcon />,
      },
    ],
  },
  {
    segment: 'utilities',
    title: 'Utilities',
    icon: <HomeRepairServiceIcon />,
    children: [
      {
        segment: 'proof',
        title: 'VD - Proof',
        icon: <SpellcheckIcon />,
      },
    ],
  },
  {
    segment: 'documentation',
    title: 'Documentation',
    icon: <DescriptionIcon />,
    children: [
      {
        segment: 'video-display',
        title: 'Production - Video Displays',
        icon: <SpellcheckIcon />,
      },
      {
        segment: 'data-merge',
        title: 'Data merge - Howto',
        icon: <SpellcheckIcon />,
      },
    ],
  },
];

const BRANDING = {
  title: 'CIRCLE LAB',
  logo: <img src={LogoIcon} alt="CIRCLE LAB logo"></img>
};

function App() {
  return (
    <AuthGuard>
      <AppProvider
        navigation={NAVIGATION}
        branding={BRANDING}
      >
        <Outlet />
      </AppProvider>
    </AuthGuard>
  );
}

export default App;
